import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { ConsultarCiudadesResponse } from '../../models/cotizador-contratante/consultar-ciudades/consultar-ciudades-response.model';
import { URL_MAP } from '../../shared/urlMap';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConsultarCiudadesService {
  private readonly apiUrl = `${environment.HOST}${URL_MAP.API.CONSULTAR_CIUDADES}`;

  constructor(private httpClient: HttpClient) { }

  consultarCiudades(): Observable<ConsultarCiudadesResponse> {
    return this.httpClient.get<ConsultarCiudadesResponse>(this.apiUrl).pipe(
      catchError(error => {
        console.error('Error en consultarCiudades: ', error);
        return throwError(() => new Error(error?.message || 'Error al consultar ciudades'));
      })
    );
  }
}
